import React from 'react'

export default function FilterCloseGrayIcon() {
    return (
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fillRule="evenodd" clipRule="evenodd" d="M4.22347 4.22347C4.52143 3.92551 5.00452 3.92551 5.30248 4.22347L11.7765 10.6975C12.0745 10.9955 12.0745 11.4786 11.7765 11.7765C11.4786 12.0745 10.9955 12.0745 10.6975 11.7765L4.22347 5.30248C3.92551 5.00452 3.92551 4.52143 4.22347 4.22347Z" fill="#64617E" />
            <path fillRule="evenodd" clipRule="evenodd" d="M4.22347 11.7765C3.92551 11.4786 3.92551 10.9955 4.22347 10.6975L10.6975 4.22347C10.9955 3.92551 11.4786 3.92551 11.7765 4.22347C12.0745 4.52143 12.0745 5.00452 11.7765 5.30248L5.30248 11.7765C5.00452 12.0745 4.52143 12.0745 4.22347 11.7765Z" fill="#64617E" />
        </svg>
    )
}
